/**
 * -------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation.  All Rights Reserved.  Licensed under the MIT License.
 * See License in the project root for license information.
 * -------------------------------------------------------------------------------------------
 */
/**
 * @enum
 * Enum for RequestMethods
 * @property {string} GET - The get request type
 * @property {string} PATCH - The patch request type
 * @property {string} POST - The post request type
 * @property {string} PUT - The put request type
 * @property {string} DELETE - The delete request type
 */
export var RequestMethod;
(function (RequestMethod) {
  RequestMethod["GET"] = "GET";
  RequestMethod["PATCH"] = "PATCH";
  RequestMethod["POST"] = "POST";
  RequestMethod["PUT"] = "PUT";
  RequestMethod["DELETE"] = "DELETE";
})(RequestMethod || (RequestMethod = {}));